import english from './en';
import norwegian from './no';

export default {
  'en-GB': english,
  'nb-NO': norwegian,
};
